<template>
    <c-dialog ref="dialog" title="资产档案借还记录" mode="slide" width="800" enable-flex mask-close :button="false">
        <template #head>
            <div class="m-detail-tag flex-center-cross">
                <label>{{detailData.asset_code}} | {{detailData.asset_name}}</label>
                <c-state dict="assetUseStatusDic" tag :value="detailData.current_status"></c-state>
            </div>
        </template>

        <div class="m-detail-box">
            <c-table ref="recordList" height="grow" :paging="true">
                <c-table-column label="操作类型" width="80">
                    <template #default="{data}">
                        <span v-if="data.operation_type == 1" style="color: brown">借用</span>
                        <span v-if="data.operation_type == 2" style="color: green">归还</span>
                    </template>
                </c-table-column>
                <c-table-column label="归属网点" width="150">
                    <template #default="{data}">
                        <span>{{data.outlet_name}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="借用网点" width="150">
                    <template #default="{data}">
                        <span>{{data.ref_outlet_name}}</span>
                    </template>
                </c-table-column>

                <c-table-column label="操作人" width="120">
                    <template #default="{data}">
                        <span>{{data.create_user_realname}}</span>
                    </template>
                </c-table-column>

                <c-table-column label="操作时间" width="140">
                    <template #default="{data}">
                        <span>{{data.create_date||'-'}}</span>
                    </template>
                </c-table-column>
            </c-table>
        </div>
    </c-dialog>
</template>

<script>
export default {
    name: 'assetBorrowRecordListDialog',
    props: {
    },
    data() {
        return {
            detailData:{}
        }
    },
    methods: {
        /********搜索************/
        searchHandle(data){
            if (!data){
                data = {};
            }
            this.$refs.recordList.load({
                url: '/fixed_asset/operation/record/list',
                data,
                success: () => {}
            });
        },
        open(data) {
            this.detailData = data;
            var params = {}
            params.asset_id = data.id;
            params.operation_types = [1,2];//表示借还操作记录
            this.searchHandle(params);
            this.$refs.dialog.open();
        }
    }
}
</script>